export default __webpack_public_path__ + "static/media/AM.0977c884.png";